import "./SectionSeparator.css";

const DOTS = [
	{ size: 3, color: "#C9A5A0" },
	{ size: 4, color: "#8B7B9D" },
	{ size: 6, color: "#7EBBA3" },
	{ size: 8, color: "#6B9E8D" },
	{ size: 10, color: "#C9A876" },
	{ size: 12, color: "#D4847A" },
	{ size: 10, color: "#C9A876" },
	{ size: 8, color: "#6B9E8D" },
	{ size: 6, color: "#7EBBA3" },
	{ size: 4, color: "#8B7B9D" },
	{ size: 3, color: "#C9A5A0" },
];

const SectionSeparator = ({ title }) => (
	<div className="section-separator">
		{title && <h2 className="section-separator-title">{title}</h2>}
		<div className="section-separator-dots">
			{DOTS.map((dot, i) => (
				<span
					key={`${dot.color}-${i}`}
					className="section-separator-dot"
					style={{
						"--dot-size": `${dot.size}px`,
						"--dot-color": dot.color,
						"--dot-i": i,
					}}
				/>
			))}
		</div>
	</div>
);

export default SectionSeparator;
